import Mention from '../../../javascripts/components/Mention';

if (!window?.Coorum) {
  window.Coorum = {};
}
window.Coorum.Mention = Mention;

document.addEventListener('DOMContentLoaded', () => {
  const $mention = document.querySelector('.js-mention');
  if ($mention) {
    const mention = new Coorum.Mention($mention);
    mention.setEvents();
  }
});
